export const escapeCsvValue = (value: unknown): string =>
  `"${String(value ?? '')
    .replaceAll('\r\n', '\n')
    .replaceAll('\r', '\n')
    .replaceAll('"', '""')}"`
